import { toast } from 'react-toastify';

export const NOTIFICATION_TYPE_INFO = 'info';
export const NOTIFICATION_TYPE_SUCCESS = 'success';
export const NOTIFICATION_TYPE_WARNING = 'warning';
export const NOTIFICATION_TYPE_ERROR = 'error';

export const notify = (type, message, autoClose = 5000) => {

  toast.dismiss();
  switch (type) {
    case NOTIFICATION_TYPE_INFO:
      toast.success(message, {
        autoClose: autoClose,
        position: "bottom-right"
        //  position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     theme: "light",
      });
      break;
    case NOTIFICATION_TYPE_SUCCESS:
      toast.success(message, {
        autoClose: autoClose,
        position: "bottom-right"
      });
      break;
    case NOTIFICATION_TYPE_WARNING:
      toast.warning(message, {
        autoClose: autoClose,
        position: "bottom-right"
      });
      break;
    case NOTIFICATION_TYPE_ERROR:
      toast.error(message, {
        autoClose: autoClose,
        position: "bottom-right"
      });
      break;
    default:
  }
}